module.exports = __webpack_public_path__ + "img/star-new.21a7e9c7.svg";